import { render } from "./ImagerieDent.vue?vue&type=template&id=f9b8dd38&scoped=true"
import script from "./ImagerieDent.vue?vue&type=script&lang=js"
export * from "./ImagerieDent.vue?vue&type=script&lang=js"

import "./ImagerieDent.vue?vue&type=style&index=0&id=f9b8dd38&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b8dd38"]])

export default __exports__